import React, { useEffect, useMemo, useState } from "react";
import { Icon } from "@iconify/react";
import { TableContainer } from "@mui/material";
import { thStyle, tdStyle, inputStyle } from "../addstock/tableStyles";
import { Button, Typography, TextField } from "@mui/material";
import style from "./Customer.module.css";
import CustomerTable from "./customer";
import { formatDate, LotAuditColumns, selectStyle } from "utils/helpers";
import { fetchLotAuditReports } from "services/invoiceServices";
import { useQuery } from "@tanstack/react-query";
import { Controller, useForm } from "react-hook-form";
import { FaSearch } from "react-icons/fa";
import Select from "react-select";
import useDebounce from "hooks/useDebounce";
import toast from "react-hot-toast";
import PageLoader from "Components/PageLoader";
export default function LotAuditReport({
  clientCode,
  allCategories,
  allVendors,
}) {
  const { data: lotAuditReports,isLoading,isError } = useQuery({
    queryKey: ["purchaseReport/lotAuditReports", clientCode],
    queryFn: fetchLotAuditReports,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });

  

  const {
    register,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      SearchQuery: "",
      stockType: "",
      category: "",
      vendor: "",
    },
  });
  const stockType = watch("stockType");
  const category = watch("category");
  const vendor = watch("vendor");
  const SearchQuery = watch("SearchQuery");
  const debouncedSearchQuery = useDebounce(SearchQuery,1500)
  const [activeList, setActiveList] = useState(true);
  const [loading, setLoading] = useState(false);


  
  useEffect(()=>{
    if(isError){
      toast.error("Failed to fetch report, trye again later", {
        duration: 3000,
        position: "center"
      });
    }
  },[isError])
  const filteredData = useMemo(() => {
    let result = lotAuditReports?.map((item)=>{
      let date = item?.PurchaseEntryDate ? formatDate(item.PurchaseEntryDate) : ""
      return {...item,
        StockTotalWt:(+(item?.StockTotalWt || 0))?.toFixed(3),
        StockPackingWt:(+(item?.StockPackingWt || 0))?.toFixed(3),
        StockNetWt:(+(item?.StockNetWt || 0))?.toFixed(3),
        StockGrossWt:(+(item?.StockGrossWt || 0))?.toFixed(3),
        SaleGrossWt:(+(item?.SaleGrossWt || 0))?.toFixed(3),
        PurchaseTotalWt:(+(item?.PurchaseTotalWt || 0))?.toFixed(3),
        PurchasePackingWt:(+(item?.PurchasePackingWt || 0))?.toFixed(3),
        PurchaseNetWt:(+(item?.PurchaseNetWt || 0))?.toFixed(3),
        PurchaseGrossWt:(+(item?.PurchaseGrossWt || 0))?.toFixed(3),
        NetWtDifference:(+(item?.NetWtDifference || 0))?.toFixed(3),
        Difference:(+(item?.Difference || 0))?.toFixed(3),
        PurchaseEntryDate:date
      }
    });
    console.log(result)
    if (activeList == true) {
      result = result?.filter((item) => !item?.IsApproved);
    } 
    if(activeList == false) {
      result = result?.filter((item) => item?.IsApproved);
    }

    if (stockType?.value == "Labelled") {
      result = result?.filter((item) => item?.StatusType);
    }
    if (stockType?.value == "Unlabelled") {
      result = result?.filter((item) => !item?.StatusType);
    }

    if (vendor?.value) {
      result = result?.filter((item) => item?.VendorName == vendor?.value);
    }

    if (debouncedSearchQuery) {
      result = result.filter(
        (item) =>
          item?.LotNumber?.toLowerCase().includes(debouncedSearchQuery.toLowerCase()) ||
          item?.VendorName?.toLowerCase().includes(debouncedSearchQuery.toLowerCase())
      );
    }
    return result;
  }, [lotAuditReports, activeList, stockType, category, vendor,debouncedSearchQuery]);

 
  

  const  dropdown = (data,key)=>{
    let result = []
    if(key == "category"){
     result =   data?.map((x) => ({
        value: x.Id,
        label: x.CategoryName,
      })) || [];
    }
    if(key == "vendor"){
    result =  data?.map((x) => ({
        value: x.VendorName,
        label: x.VendorName,
      })) || [];
    }
    if(key == "stockType"){
    result =  [{ value: "Labelled", label: "Labelled" },
      { value: "Unlabelled", label: "Unlabelled" }]
    }
    return  [{ value: "", label: "-- select --" }].concat(result)
  }


  console.log(filteredData)
  return (
    <>
     {isLoading || loading && (
      <PageLoader />
     )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "10px 10px 8px 10px",
        }}
      >
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          {/* Stock Type */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <label style={{ fontSize: "14px", marginBottom: "4px" }}>
              Stock Type
            </label>

            <Controller
              name={"stockType"}
              control={control}
              render={({ field: controllerField }) => (
                <Select
                  {...controllerField}
                  options={dropdown([],"stockType")}
                  placeholder="-- select --"
                  // {...register("stockType")}
                  styles={{ control: (base) => ({ ...base }) }}
                  isClearable={true}
                />
              )}
            />
          </div>

          {/* Category */}
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <label style={{ fontSize: "14px", marginBottom: "4px" }}>
              Category
            </label>

            <Controller
              name={"category"}
              control={control}
              render={({ field: controllerField }) => (
                <Select
                  {...controllerField}
                  options={dropdown(allCategories,"category")}
                  placeholder="-- select --"
                  // {...register("category")}
                  styles={{ control: (base) => ({ ...base }) }}
                  isClearable={true}
                />
              )}
            />
          </div> */}

          {/* Vendor */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <label style={{ fontSize: "14px", marginBottom: "4px" }}>
              Vendor
            </label>
            <Controller
              name={"vendor"}
              control={control}
              render={({ field: controllerField }) => (
                <Select
                  {...controllerField}
                  options={dropdown(allVendors,"vendor")}
                  placeholder="-- select --"
                  // {...register("vendor")}
                  styles={{ control: (base) => ({ ...base }) }}
                  isClearable={true}
                />
              )}
            />
          </div>
        </div>

        {/* Search Input */}
        <div
          style={{
            borderRadius: "50px",
            padding: "2px 10px",
            border: "1px solid gray",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <FaSearch />
          <input
            {...register("SearchQuery")}
            placeholder="Search"
            style={{
              background: "#fff",
              outline: "none",
              border: "none",
              boxShadow: "none",
            }}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          onClick={() => setActiveList(true)}
          style={{
            flex: "1",
            cursor: "pointer",
            background: `${activeList == true ? "#627383" : "#D3D3D3"}`,
            color: `${activeList == 1 ? "#fff" : ""}`,
            padding: "10px",
          }}
        >
          Pending List
        </div>
        <div
          onClick={() => setActiveList(false)}
          style={{
            flex: "1",
            cursor: "pointer",
            background: `${activeList == false ? "#627383" : "#D3D3D3"}`,
            color: `${activeList == 2 ? "#fff" : ""}`,
            padding: "10px",
          }}
        >
          Approved List
        </div>
      </div>
      <CustomerTable
        columns={LotAuditColumns}
        allCategories={filteredData?.length ? filteredData : []}
        handleEditData={() => {}}
        handlePrint={(product) => console.log(product)}
        searchInput={""}
        setSearchInput={() => {}}
      />
    </>
  );
}
